<template>
  <div id="footer">
    <div class="footer_bot">
      <div class="msg warp">
        <div class="msg_item copy">
          广东省环境科学学会©版权所有&nbsp;&nbsp;
          广东省环境科学学会				</div>
        <div class="msg_item">
									<span class="phone">
						电话：020-83700890					</span>
          <span class="fax">
						传真：020-83700890					</span>
          <span class="email">
						邮箱：<a href="mailto:gdhjxh@126.com">gdhjxh@126.com</a>
					</span>
        </div>
        <div class="msg_item">
									<span class="address">
						地址：广州市越秀区连新路171号广东科学馆主楼					</span>
          <span class="icp">
						&nbsp;<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">{{ state.config.beian }}</a>
					</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, reactive} from "vue";
import {getRequest} from "@/assets/js/common";

const state = reactive({
  config:'',
});
const getConfig = () => {
  getRequest('/config')
      .then(res => {
        if(res.code){
          state.config = res.data;
        }
      })
      .catch(error => {
      }).finally(() => {
  });
}
onMounted(()=>{
  getConfig();
})
</script>

<style scoped>
#footer {
  padding: 30px 0;
  background: #000;
}
#footer .footer_bot {
  width: 100%;
}
.warp {
  width: 1200px;
  min-width: 1200px;
  margin: 0 auto;
}
#footer .footer_bot .msg .msg_item:first-child {
  margin-top: 0;
}
#footer .footer_bot .msg .msg_item {
  margin-top: 8px;
  width: 100%;
  height: 21px;
  font-size: 12px;
  color: #fff;
  text-align: center;
}
#footer .footer_bot .msg .msg_item {
  margin-top: 8px;
  width: 100%;
  height: 21px;
  font-size: 12px;
  color: #fff;
  text-align: center;
}
#footer .footer_bot .msg .msg_item a {
  font-size: 12px;
  color: #fff;
}
#footer .footer_bot .msg .msg_item a:hover {
  text-decoration: underline;
}
</style>
